import checkAccess from 'utils/roles/checkAccess';

export const routerPath = {
  root: '/Brands',
};

export const getColumns = ({ editItem, deleteItem }) => {
  const initialArr = [
    {
      id: 'imageId',
      type: 'avatar',
      label: 'Avatar',
      align: 'left',
      disableSort: 'true',
      sx: {
        width: '80px',
      },
    },
    { id: 'name', label: 'Brand', align: 'left' },
  ];

  if (checkAccess([0, 1, 2])) {
    return [
      ...initialArr,
      {
        id: 'more-menu',
        type: 'menu',
        items: [
          {
            id: 1,
            name: 'Delete',
            action: (id) => deleteItem(id),
            icon: 'eva:trash-2-outline',
            sx: { color: 'error.main' },
          },
          { id: 2, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
        ],
        disableSort: true,
      },
    ];
  }

  return initialArr;
};

export const getFilters = ({ searchBy }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Brand name',
    action: searchBy.change,
  },
];
